// Native (Capacitor) runtime helpers. On the web this module is inert:
// the session keeps living in the httpOnly cookie and nothing is stored.
import { Preferences } from "@capacitor/preferences";

const TOKEN_KEY = "skinly_access_token";

export const isNative = () => !!window.Capacitor?.isNativePlatform?.();

export const getNativeToken = async () => {
  if (!isNative()) return null;
  const { value } = await Preferences.get({ key: TOKEN_KEY });
  return value || null;
};

export const setNativeToken = async (token) => {
  if (!isNative() || !token) return;
  await Preferences.set({ key: TOKEN_KEY, value: token });
};

export const clearNativeToken = async () => {
  if (!isNative()) return;
  await Preferences.remove({ key: TOKEN_KEY });
};
